import type {Seller} from './types';

export type ChatParticipant = {
  name: string;
  avatar: string;
  is_shop: boolean;
};

type ParticipantFallback = {
  name?: string;
  avatar?: string;
  is_shop?: boolean;
};

type MembershipMember = {
  is_shop?: boolean | number;
  full_name?: string;
  profile_picture?: string;
  branding?: {name?: string; avatar?: string} | null;
};

type ProfileIdentity = {
  isShop?: boolean;
  full_name?: string;
  profile_picture?: string;
  shopName?: string;
  shopAvatar?: string;
};

const buildParticipant = (
  isShop: boolean,
  shopName: string | undefined,
  shopAvatar: string | undefined,
  memberName: string | undefined,
  memberAvatar: string | undefined
): ChatParticipant => ({
  name: (isShop && shopName) || memberName || '',
  avatar: (isShop && shopAvatar) || memberAvatar || '',
  is_shop: isShop,
});

export const participantFromListingSeller = (seller?: Seller | null): ChatParticipant | null => {
  if (!seller) return null;
  return {
    name: seller.full_name || '',
    avatar: seller.profile_picture || '',
    is_shop: Boolean(seller.is_shop),
  };
};

export const participantFromMembership = (member?: MembershipMember | null): ChatParticipant | null => {
  if (!member) return null;
  return buildParticipant(
    Boolean(Number(member.is_shop)),
    member.branding?.name,
    member.branding?.avatar,
    member.full_name,
    member.profile_picture
  );
};

export const participantFromProfile = (profile?: ProfileIdentity | null): ChatParticipant | null => {
  if (!profile) return null;
  return buildParticipant(
    Boolean(profile.isShop),
    profile.shopName,
    profile.shopAvatar,
    profile.full_name,
    profile.profile_picture
  );
};

export const mergeParticipant = (
  fresh: ChatParticipant | null,
  fallback?: ParticipantFallback | null
): ChatParticipant => ({
  name: fresh?.name || fallback?.name || '',
  avatar: fresh?.avatar || fallback?.avatar || '',
  is_shop: fresh ? fresh.is_shop : Boolean(fallback?.is_shop),
});
